// extracted by mini-css-extract-plugin
export default {"box":"TextUI_box__j4HOU","input":"TextUI_input__ydS-g","error":"TextUI_error__RsaT5"};